import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlogEntryComponent } from '../blog-entry/blog-entry.component';

@Component({
  selector: 'tvoed-blog',
  standalone: true,
  imports: [CommonModule, BlogEntryComponent],
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.scss']
})
export class BlogComponent {
  blogEntries = [
    {
      headline: 'Wie berechnet sich das Jahresgehalt im Tarifvertrag für den öffentlichen Dienst?',
      date: '27.02.2026',
      paragraphs: [
        {
          content:
            'Das Jahresgehalt im TVöD setzt sich aus mehreren Bestandteilen zusammen. Neben dem monatlichen Tabellenentgelt gibt es Sonderzahlungen, Zulagen und leistungsorientierte Komponenten. Im Folgenden erklären wir die einzelnen Bestandteile.'
        },
        {
          headline: 'Monatliches Tabellenentgelt',
          content:
            'Das monatliche Tabellenentgelt ist die Grundlage des Gehalts und ergibt sich aus der Eingruppierung in eine Entgeltgruppe (E 1 bis E 15) und der jeweiligen Erfahrungsstufe (Stufe 1 bis 6). Die Eingruppierung richtet sich nach der ausgeübten Tätigkeit, während die Stufenzuordnung von der Berufserfahrung abhängt. Die Entgelttabellen werden regelmäßig im Rahmen von Tarifverhandlungen angepasst.'
        },
        {
          headline: 'Wöchentliche Arbeitszeit',
          content:
            'Die regelmäßige wöchentliche Arbeitszeit beträgt im TVöD (Bund) 39 Stunden und im TVöD (VKA) ebenfalls 39 Stunden. Abweichungen können sich durch individuelle Vereinbarungen, Teilzeit oder tarifliche Sonderregelungen ergeben. Zusätzliche Arbeitsstunden über die regelmäßige Arbeitszeit hinaus können zu Überstundenzuschlägen führen.'
        },
        {
          headline: 'Jahressonderzahlung',
          content:
            'Die Jahressonderzahlung (umgangssprachlich "Weihnachtsgeld") wird im November ausgezahlt und ist in § 20 TVöD geregelt. Ihre Höhe hängt von der Entgeltgruppe ab und beträgt zwischen ca. 60% und 90% des Monatsentgelts. Beschäftigte in den unteren Entgeltgruppen erhalten prozentual eine höhere Jahressonderzahlung.'
        },
        {
          headline: 'Leistungsentgelt (LOB)',
          content:
            'Das Leistungsentgelt gemäß § 18 TVöD ist eine leistungsorientierte Bezahlung, die als jährliche Einmalzahlung gewährt wird. Das tarifliche Gesamtvolumen beträgt 2% der ständigen Monatsentgelte des Vorjahres aller Beschäftigten. Die individuelle Höhe wird durch systematische Leistungsbewertung und/oder Zielvereinbarung bestimmt und kann je nach Leistung variieren.'
        },
        {
          headline: 'Zulagen und Zuschläge',
          content:
            'Im TVöD gibt es verschiedene Zulagen und Zuschläge, die das Gehalt erhöhen können. Dazu gehören unter anderem: Wechselschichtzulage (§ 8 Abs. 5 TVöD) für ständige Wechselschichtarbeit, Nachtzuschlag (20% des Stundenentgelts pro Nachtstunde), Samstags-, Sonntags- und Feiertagszuschläge (20-135% je nach Tag), Überstundenzuschläge (30% für E 1 bis E 9b) sowie Funktionszulagen für besondere Verantwortung.'
        },
        {
          headline: 'Vermögenswirksame Leistungen',
          content:
            'Beschäftigte im öffentlichen Dienst haben Anspruch auf vermögenswirksame Leistungen (VL) in Höhe von 6,65 € monatlich (§ 23 Abs. 1 TVöD). Diese werden auf einen VL-Vertrag des Beschäftigten überwiesen.'
        },
        {
          headline: 'Berechnung des Jahresbruttogehalts',
          content:
            'Das Jahresbruttogehalt ergibt sich somit aus: 12 × monatliches Tabellenentgelt (inkl. Zulagen und Zuschläge) + Jahressonderzahlung + Leistungsentgelt. Je nach individueller Situation können weitere Sonderzahlungen oder tarifliche Zusatzleistungen hinzukommen.'
        }
      ]
    },
    {
      headline: 'Willkommen auf tvoedgehalt.de!',
      date: '26.02.2026',
      paragraphs: [
        {
          content:
            'Ab sofort steht euch mit tvoedgehalt.de ein neuer Gehaltsrechner für den öffentlichen Dienst zur Verfügung. Hier könnt ihr schnell und einfach euer Gehalt nach dem Tarifvertrag für den öffentlichen Dienst (TVöD) berechnen.'
        },
        {
          content:
            'Der Rechner berücksichtigt die aktuellen TVöD-Entgelttabellen und ermöglicht es euch, eure Entgeltgruppe und Stufe auszuwählen, um euer monatliches Bruttogehalt zu ermitteln. Zusätzlich findet ihr unter "Tariftabellen" eine Übersicht aller aktuellen TVöD-Entgelttabellen.'
        },
        {
          content:
            'Falls euch Fehler auffallen oder ihr Verbesserungsvorschläge habt, meldet euch gerne per Mail an bug@tvoedgehalt.de. Viel Spaß mit dem Rechner!'
        }
      ]
    }
  ];
}
